import moment from "moment";
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/it";
import "moment/locale/pt";

export const changeMomentLang = newLang => {
  moment.locale(newLang);
};

changeMomentLang("en"); // By default english
